<template>
  <div class="flex flex-col">
    <div class="-my-2 sm:-mx-6 lg:-mx-8"
         :class="{ 'overflow-x-auto': autoOverflowX }">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <slot name="header" />
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <slot />
            </tbody>
          </table>

          <slot name="footer" />

          <nav v-if="pagination"
               class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
               aria-label="Pagination">
            <div class="hidden sm:block">
              <p class="text-sm text-gray-700">
                Showing
                {{ ' ' }}
                <span class="font-medium">{{ pagination.from }}</span>
                {{ ' ' }}
                to
                {{ ' ' }}
                <span class="font-medium">{{ pagination.to }}</span>
                {{ ' ' }}
                of
                {{ ' ' }}
                <span class="font-medium">{{ pagination.total }}</span>
                {{ ' ' }}
                results
              </p>
            </div>
            <div class="flex-1 flex justify-between sm:justify-end">
              <Link :href="pagination.prev_page_url || '#'"
                    :class="{ 'invisible': ! pagination.prev_page_url }"
                    class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Previous
              </Link>
              <Link :href="pagination.next_page_url || '#'"
                    :class="{ 'invisible': ! pagination.next_page_url }"
                    class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Next
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
:deep(th) {
  @apply px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider;
}

:deep(th:last-child) {
  @apply relative px-6 py-3;
}

:deep(td) {
  @apply px-6 py-4 whitespace-nowrap text-sm text-gray-500;
}

tbody :deep(td) {
  &.-wrap {
    @apply whitespace-normal;
  }
}

:deep(td:first-child) {
  @apply font-medium text-gray-900;
}

:deep(td:last-child):not(.-left) {
  @apply text-right font-medium;
}
</style>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    pagination: Object,
    required: false,
    autoOverflowX: {
      type: Boolean,
      default: true,
    }
  },
}
</script>
